module.exports = __webpack_public_path__ + "static/media/new_profile_image_cropped.9911ab5f.png";